import { SolIcon } from '@sol/icons';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { SolNavbar, SolNavbarItem } from '@sol/components';

export const navbarPlatform: SolNavbar = {
  menu: [
    SolNavbarItem.of(AsmRouteId.dashboard, {
      displayName: 'asm-route.dashboard',
      icon: SolIcon.asm_dashboard,
      embedTabGroup: true,
    }),
    SolNavbarItem.of(AsmRouteId.tracker, {
      displayName: 'asm-route.tracker',
      icon: SolIcon.asm_tracker,
      showChildrenInNavbar: false,
      children: [
        SolNavbarItem.of(AsmRouteId.tracker_detail, {
          displayName: 'asm-route.tracker-detail',
          nameParams: ['observationLabel'],
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.tracker_detail_overview, {
              displayName: 'asm-route.tracker-detail.overview',
            }),
            SolNavbarItem.of(AsmRouteId.tracker_detail_activity, {
              displayName: 'asm-route.tracker-detail.activity',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.drp, {
      displayName: 'asm-route.drp',
      icon: SolIcon.asm_drp,
      children: [
        SolNavbarItem.of(AsmRouteId.drp_credentials, {
          displayName: 'asm-route.atp',
          icon: SolIcon.leaked_secrets,
          showChildrenAsTabs: true,
          embedTabGroup: true,
          children: [
            SolNavbarItem.of(AsmRouteId.atp_exposedAccounts, {
              displayName: 'asm-route.atp.exposed-accounts',
              children: [
                SolNavbarItem.of(AsmRouteId.atp_exposedAccounts_detail, {
                  displayName: 'asm-route.atp.exposed-account-detail',
                  nameParams: ['accountName'],
                  showChildrenAsTabs: true,
                  children: [
                    SolNavbarItem.of(AsmRouteId.atp_exposedAccounts_detail_overview, {
                      displayName: 'asm-route.atp.overview',
                    }),
                    SolNavbarItem.of(AsmRouteId.atp_exposedAccounts_detail_scoring, {
                      displayName: 'asm-route.atp.scoring',
                    }),
                    SolNavbarItem.of(AsmRouteId.atp_exposedAccounts_detail_activity, {
                      displayName: 'asm-route.atp.activity',
                    }),
                  ],
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.atp_exposedCookies, {
              displayName: 'asm-route.atp.exposed-cookies',
              children: [
                SolNavbarItem.of(AsmRouteId.atp_exposedCookies_detail, {
                  displayName: 'asm-route.atp.exposed-cookie-detail',
                  nameParams: ['cookieName'],
                  showChildrenAsTabs: true,
                  children: [
                    SolNavbarItem.of(AsmRouteId.atp_exposedCookies_detail_overview, {
                      displayName: 'asm-route.atp.overview',
                    }),
                    SolNavbarItem.of(AsmRouteId.atp_exposedCookies_detail_scoring, {
                      displayName: 'asm-route.atp.scoring',
                    }),
                    SolNavbarItem.of(AsmRouteId.atp_exposedCookies_detail_activity, {
                      displayName: 'asm-route.atp.activity',
                    }),
                  ],
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.atp_exposureArtifacts, {
              displayName: 'asm-route.atp.exposure-artifacts',
              children: [
                SolNavbarItem.of(AsmRouteId.atp_exposureArtifacts_detail, {
                  displayName: 'asm-route.atp.exposure-artifact-detail',
                  nameParams: ['artifactName'],
                  showChildrenAsTabs: true,
                  children: [
                    SolNavbarItem.of(AsmRouteId.atp_exposureArtifacts_detail_overview, {
                      displayName: 'asm-route.atp.overview',
                    }),
                    SolNavbarItem.of(AsmRouteId.atp_exposureArtifacts_detail_scoring, {
                      displayName: 'asm-route.atp.scoring',
                    }),
                    SolNavbarItem.of(AsmRouteId.atp_exposureArtifacts_detail_activity, {
                      displayName: 'asm-route.atp.activity',
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.drp_darkWeb, {
          displayName: 'asm-route.dark-web',
          icon: SolIcon.asm_dark_web,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.drp_darkWeb_detail, {
              displayName: 'asm-route.dark-web-detail',
              nameParams: ['webContentLabel'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.drp_darkWeb_detail_overview, {
                  displayName: 'asm-route.drp-detail.overview',
                }),
                SolNavbarItem.of(AsmRouteId.drp_darkWeb_detail_activity, {
                  displayName: 'asm-route.drp-detail.activity',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.drp_dataLeakage, {
          displayName: 'asm-route.data-leakage',
          icon: SolIcon.asm_data_leakage,
          isNew: true,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.drp_dataLeakage_detail, {
              displayName: 'asm-route.data-leakage-detail',
              nameParams: ['webContentLabel'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.drp_dataLeakage_detail_overview, {
                  displayName: 'asm-route.drp-detail.overview',
                }),
                SolNavbarItem.of(AsmRouteId.drp_dataLeakage_detail_activity, {
                  displayName: 'asm-route.drp-detail.activity',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.drp_mobileApps, {
          displayName: 'asm-route.mobile-apps',
          icon: SolIcon.asm_mobile_apps,
          isNew: true,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.drp_mobileApps_detail, {
              displayName: 'asm-route.mobile-apps-detail',
              nameParams: ['webContentLabel'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.drp_mobileApps_detail_overview, {
                  displayName: 'asm-route.drp-detail.overview',
                }),
                SolNavbarItem.of(AsmRouteId.drp_mobileApps_detail_activity, {
                  displayName: 'asm-route.drp-detail.activity',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.drp_socialMedia, {
          displayName: 'asm-route.social-media',
          icon: SolIcon.asm_social_media,
          isNew: true,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.drp_socialMedia_detail, {
              displayName: 'asm-route.social-media-detail',
              nameParams: ['webContentLabel'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.drp_socialMedia_detail_overview, {
                  displayName: 'asm-route.drp-detail.overview',
                }),
                SolNavbarItem.of(AsmRouteId.drp_socialMedia_detail_activity, {
                  displayName: 'asm-route.drp-detail.activity',
                }),
              ],
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.assets, {
      displayName: 'asm-route.assets',
      icon: SolIcon.asm_assets,
      showBadge: true,
      children: [
        SolNavbarItem.of(AsmRouteId.assets_certificates, {
          displayName: 'asm-route.certificates',
          icon: SolIcon.asm_certificates,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.assets_certificates_detail, {
              displayName: 'asm-route.certificates-detail',
              nameParams: ['certificateSerial'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.assets_certificates_detail_overview, {
                  displayName: 'asm-route.assets.overview',
                }),
                SolNavbarItem.of(AsmRouteId.assets_certificates_detail_findings, {
                  displayName: 'asm-route.assets.findings',
                }),
                SolNavbarItem.of(AsmRouteId.assets_certificates_detail_scoring, {
                  displayName: 'asm-route.assets.scoring',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.assets_domainDiscovery, {
          displayName: 'asm-route.domain-discovery',
          icon: SolIcon.asm_domain_discovery,
          showBadge: true,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.assets_domainDiscovery_detail, {
              displayName: 'asm-route.domain-discovery-detail',
              nameParams: ['domainName'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.assets_domainDiscovery_detail_overview, {
                  displayName: 'asm-route.assets.overview',
                }),
                SolNavbarItem.of(AsmRouteId.assets_domainDiscovery_detail_activity, {
                  displayName: 'asm-route.assets.activity',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.assets_domains, {
          displayName: 'asm-route.domains',
          icon: SolIcon.asm_domains,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.assets_domains_detail, {
              displayName: 'asm-route.domains-detail',
              nameParams: ['domainName'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.assets_domains_detail_overview, {
                  displayName: 'asm-route.assets.overview',
                }),
                SolNavbarItem.of(AsmRouteId.assets_domains_detail_findings, {
                  displayName: 'asm-route.assets.findings',
                }),
                SolNavbarItem.of(AsmRouteId.assets_domains_detail_scoring, {
                  displayName: 'asm-route.assets.scoring',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.assets_hosts, {
          displayName: 'asm-route.hosts',
          icon: SolIcon.asm_hosts,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.assets_hosts_detail, {
              displayName: 'asm-route.hosts-detail',
              nameParams: ['ip'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.assets_hosts_detail_overview, {
                  displayName: 'asm-route.assets.overview',
                }),
                SolNavbarItem.of(AsmRouteId.assets_hosts_detail_findings, {
                  displayName: 'asm-route.assets.findings',
                }),
                SolNavbarItem.of(AsmRouteId.assets_hosts_detail_scoring, {
                  displayName: 'asm-route.assets.scoring',
                }),
                SolNavbarItem.of(AsmRouteId.assets_hosts_detail_scanHistory, {
                  displayName: 'asm-route.hosts.scan-history',
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.assets_websites, {
          displayName: 'asm-route.websites',
          icon: SolIcon.asm_websites,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.assets_websites_detail, {
              displayName: 'asm-route.websites-detail',
              nameParams: ['url'],
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.assets_websites_detail_overview, {
                  displayName: 'asm-route.assets.overview',
                }),
                SolNavbarItem.of(AsmRouteId.assets_websites_detail_findings, {
                  displayName: 'asm-route.assets.findings',
                }),
                SolNavbarItem.of(AsmRouteId.assets_websites_detail_scoring, {
                  displayName: 'asm-route.assets.scoring',
                }),
              ],
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.insights, {
      displayName: 'asm-route.insights',
      icon: SolIcon.asm_insights,
      children: [
        SolNavbarItem.of(AsmRouteId.insights_reports, {
          displayName: 'asm-route.reports',
          icon: SolIcon.asm_dashboard,
          showChildrenInNavbar: false,
          showChildrenAsTabs: true,
          embedTabGroup: true,
          children: [
            SolNavbarItem.of(AsmRouteId.insights_reports_overview, {
              displayName: 'asm-route.reports.overview',
            }),
            SolNavbarItem.of(AsmRouteId.insights_reports_instances, {
              displayName: 'asm-route.reports.instances',
              children: [
                SolNavbarItem.of(AsmRouteId.insights_reports_instance_detail, {
                  displayName: 'asm-route.reports.instance-detail',
                  nameParams: ['reportName'],
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.insights_reports_templates, {
              displayName: 'asm-route.reports.templates',
              children: [
                SolNavbarItem.of(AsmRouteId.insights_reports_template_detail, {
                  displayName: 'asm-route.reports.template-detail',
                  nameParams: ['templateName'],
                  children: [
                    SolNavbarItem.of(AsmRouteId.insights_reports_template_generate, {
                      displayName: 'asm-route.reports.template-generate',
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.insights_vulnerability_catalog, {
          displayName: 'asm-route.vulnerability-catalog',
          icon: SolIcon.vulnerability,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.insights_vulnerability_catalog_dashboard, {
              displayName: 'asm-route.vulnerability-catalog-dashboard',
            }),
            SolNavbarItem.of(AsmRouteId.insights_vulnerability_catalog_list, {
              displayName: 'asm-route.vulnerability-catalog-table',
              children: [
                SolNavbarItem.of(AsmRouteId.insights_vulnerability_catalog_detail, {
                  displayName: 'asm-route.vulnerability-catalog-cve-detail',
                  nameParams: ['cveId'],
                }),
              ],
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.insights_threat_explorer, {
          displayName: 'asm-route.threat-explorer',
          icon: SolIcon.radar,
          showChildrenInNavbar: false,
          children: [
            SolNavbarItem.of(AsmRouteId.insights_threat_explorer_asset, {
              displayName: 'asm-route.threat-explorer-asset',
              nameParams: ['assetName'],
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.services, {
      displayName: 'asm-route.services',
      icon: SolIcon.managed_services,
      children: [
        SolNavbarItem.of(AsmRouteId.engagementRequests, {
          displayName: 'asm-route.engagement-requests',
          icon: SolIcon.document,
          showChildrenInNavbar: false,
          showChildrenAsTabs: true,
          embedTabGroup: true,
          children: [
            SolNavbarItem.of(AsmRouteId.engagementRequests_overview, {
              displayName: 'asm-route.engagement-requests.overview',
            }),
            SolNavbarItem.of(AsmRouteId.engagementRequests_list, {
              displayName: 'asm-route.engagement-requests.list',
              children: [
                SolNavbarItem.of(AsmRouteId.engagementRequests_detail, {
                  displayName: 'asm-route.engagement-request-detail',
                  showChildrenAsTabs: true,
                  children: [
                    SolNavbarItem.of(AsmRouteId.engagementRequests_detail_overview, {
                      displayName: 'asm-route.engagement-request-detail.overview',
                    }),
                    SolNavbarItem.of(AsmRouteId.engagementRequests_detail_comments, {
                      displayName: 'asm-route.engagement-request-detail.comments',
                    }),
                  ],
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.engagementRequests_accounts, {
              displayName: 'asm-route.engagement-requests.accounts',
            }),
          ],
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.administration, {
      displayName: 'asm-route.administration',
      icon: SolIcon.asm_settings,
      children: [
        SolNavbarItem.of(AsmRouteId.settings_scope, {
          displayName: 'asm-route.scope',
          icon: SolIcon.asm_scope,
          showChildrenInNavbar: false,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(AsmRouteId.settings_scope_overview, {
              displayName: 'asm-route.scope-overview',
            }),
            SolNavbarItem.of(AsmRouteId.settings_scope_seeds, {
              displayName: 'asm-route.scope-seeds',
            }),
            SolNavbarItem.of(AsmRouteId.settings_scope_subscopes, {
              displayName: 'asm-route.subscopes',
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.administration_accessManagement, {
          displayName: 'asm-route.access-management',
          icon: SolIcon.asm_access_control,
          children: [
            SolNavbarItem.of(AsmRouteId.settings_api, {
              displayName: 'asm-route.api',
              icon: SolIcon.asm_api,
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.settings_api_tokens, {
                  displayName: 'asm-route.partner.api-tokens',
                }),
                SolNavbarItem.of(AsmRouteId.settings_api_docs, {
                  displayName: 'asm-route.partner.api-docs',
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.settings_accessControl_roles, {
              displayName: 'asm-route.partner.roles',
              icon: SolIcon.bookmark,
            }),
            SolNavbarItem.of(AsmRouteId.settings_accessControl_users, {
              displayName: 'asm-route.partner.users',
              icon: SolIcon.users,
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.administration_monitoring, {
          displayName: 'asm-route.monitoring',
          icon: SolIcon.monitor,
          children: [
            SolNavbarItem.of(AsmRouteId.settings_auditLogs, {
              displayName: 'asm-route.audit-logs',
              icon: SolIcon.asm_audit_logs,
            }),
            SolNavbarItem.of(AsmRouteId.settings_automation, {
              displayName: 'asm-route.automation',
              icon: SolIcon.asm_automation,
            }),
            SolNavbarItem.of(AsmRouteId.settings_integrations, {
              displayName: 'asm-route.integrations',
              icon: SolIcon.asm_integrations,
            }),
            SolNavbarItem.of(AsmRouteId.settings_notifications, {
              displayName: 'asm-route.notifications',
              icon: SolIcon.asm_notifications,
            }),
          ],
        }),
        SolNavbarItem.of(AsmRouteId.administration_resources, {
          displayName: 'asm-route.resources',
          icon: SolIcon.folder,
          children: [
            SolNavbarItem.of(AsmRouteId.settings_manualScans, {
              displayName: 'asm-route.manual-scans',
              icon: SolIcon.asm_manual_scans,
            }),
            SolNavbarItem.of(AsmRouteId.settings_savedSearches, {
              displayName: 'asm-route.saved-searches',
              icon: SolIcon.asm_saved_searches,
            }),
            SolNavbarItem.of(AsmRouteId.settings_tags, {
              displayName: 'asm-route.tags',
              icon: SolIcon.asm_tags,
              showChildrenAsTabs: true,
              children: [
                SolNavbarItem.of(AsmRouteId.settings_tags_user, {
                  displayName: 'asm-route.tags-user',
                  icon: SolIcon.user,
                }),
                SolNavbarItem.of(AsmRouteId.settings_tags_system, {
                  displayName: 'asm-route.tags-system',
                  icon: SolIcon.lock,
                }),
              ],
            }),
            SolNavbarItem.of(AsmRouteId.usage, {
              displayName: 'asm-route.usage',
              icon: SolIcon.usage,
              showChildrenAsTabs: true,
              embedTabGroup: true,
              children: [
                SolNavbarItem.of(AsmRouteId.usage_overview, {
                  displayName: 'asm-route.usage.overview',
                }),
                SolNavbarItem.of(AsmRouteId.usage_events, {
                  displayName: 'asm-route.usage.events',
                }),
              ],
            }),
          ],
        }),
      ],
    }),
  ],
  system: [
    SolNavbarItem.of(AsmRouteId.downloads, {
      icon: SolIcon.download,
      displayName: 'asm-route.downloads',
    }),
    SolNavbarItem.of(AsmRouteId.whatsNew, {
      displayName: 'asm-route.whats-new',
      icon: SolIcon.asm_whats_new,
    }),
    SolNavbarItem.of(AsmRouteId.debug, {
      displayName: 'asm-route.debug',
      icon: SolIcon.vulnerability,
    }),
  ],
  account: [
    SolNavbarItem.of(AsmRouteId.account_section1, {
      children: [
        SolNavbarItem.of(AsmRouteId.account_documentation, {
          displayName: 'asm-route.documentation',
        }),
        SolNavbarItem.of(AsmRouteId.account_profile, {
          displayName: 'asm-route.profile',
        }),
        SolNavbarItem.of(AsmRouteId.account_preferences, {
          displayName: 'asm-route.preferences',
        }),
      ],
    }),
    SolNavbarItem.of(AsmRouteId.account_section2, {
      children: [
        SolNavbarItem.of(AsmRouteId.account_logout, {
          displayName: 'asm-route.logout',
        }),
      ],
    }),
  ],
};
